'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactGa = require('react-ga');

var _reactGa2 = _interopRequireDefault(_reactGa);

var _PCard = require('../Common/PCard');

var _PCard2 = _interopRequireDefault(_PCard);

var _reactRouterRedux = require('react-router-redux');

var _reactRouter = require('react-router');

var _reactBootstrap = require('react-bootstrap');

var _lodash = require('lodash');

var _support = require('helpers/support');

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _reactRedux = require('react-redux');

var _voucher = require('redux/modules/voucher');

var voucherActions = _interopRequireWildcard(_voucher);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = require('./PromotionDetail.scss');

var PromotionDetail = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    campaigns: state.voucher.campaigns,
    allRewards: state.voucher.ALL_REWARD_LIST,
    promotionDetailLoaded: state.voucher.promotionDetailLoaded,
    detail: state.voucher.detail,
    isJoin: state.voucher.isJoin,
    location: state.user.coords
  };
}, (0, _extends3.default)({}, voucherActions, { push: _reactRouterRedux.push })), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(PromotionDetail, _Component);

  function PromotionDetail() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, PromotionDetail);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = PromotionDetail.__proto__ || (0, _getPrototypeOf2.default)(PromotionDetail)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      campaigns: _this.props.campaigns,
      card: {},
      showModal: false,
      firstLoad: false
    }, _this.closeModal = function () {
      _this.setState({ showModal: false });
    }, _this.onItemClick = function (campaign) {
      _reactGa2.default.event({
        category: 'Promotion',
        action: 'Clicked Voucher Card',
        label: '' + campaign.code
      });
    }, _this.renderPromotionCards = function (campaigns) {
      if (!campaigns || campaigns.length === 0) return null;
      var cards = campaigns.map(function (v, i) {
        return _react2.default.createElement(_PCard2.default, {
          key: 'pcard_' + i,
          card: (0, _support.promoData)(v),
          history: _this.props.history,
          onClick: _this.onItemClick
        });
      });
      return campaigns.length === 1 ? _react2.default.createElement(
        'div',
        { className: styles.onlyOne },
        cards
      ) : cards;
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(PromotionDetail, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.props.getAllReward({ pageSize: 1000 });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.shopId) {
        this.props.getAllCampaignByShop(this.props.shopId);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (!(0, _lodash.isEqual)(this.props.campaigns, nextProps.campaigns)) {
        this.setState({ firstLoad: true, campaigns: nextProps.campaigns });
      }
      if (this.props.shopId !== nextProps.shopId) {
        this.props.getAllCampaignByShop(nextProps.shopId);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _state = this.state,
          card = _state.card,
          showModal = _state.showModal,
          campaigns = _state.campaigns;
      var _props = this.props,
          staticOn = _props.staticOn,
          noCallHomeService = _props.noCallHomeService,
          allRewards = _props.allRewards;


      var promotionCards = void 0;
      var headerTitle = void 0;
      if (campaigns && campaigns.length > 0) {
        promotionCards = campaigns.map(function (v, i) {
          return _react2.default.createElement(_PCard2.default, {
            key: 'pcard_' + v._id,
            card: (0, _support.promoData)(v),
            history: _this2.props.history,
            onClick: _this2.onItemClick
          });
        });
        headerTitle = 'Ưu đãi của shop';
      } else {
        promotionCards = allRewards.data.map(function (v, i) {
          return _react2.default.createElement(_PCard2.default, {
            key: 'pcard_' + v._id,
            card: (0, _support.promoData)(v),
            history: _this2.props.history,
            onClick: _this2.onItemClick
          });
        });
        headerTitle = _react2.default.createElement(
          _reactRouter.Link,
          { to: '/uu-dai-tai-spa' },
          'Shop hi\u1EC7n ch\u01B0a c\xF3 \u01B0u \u0111\xE3i',
          _react2.default.createElement('br', null),
          'B\u1EA1n xem \u01B0u \u0111\xE3i t\u01B0\u01A1ng t\u1EF1 nh\xE9'
        );
      }

      return _react2.default.createElement(
        'div',
        {
          className: styles.contentTab + ' ' + styles.promo + ' ' + (staticOn && styles.staticBg)
        },
        !staticOn && _react2.default.createElement('div', { className: styles.topDynamicBg }),
        _react2.default.createElement(
          'div',
          { className: styles.headerTab },
          _react2.default.createElement(
            'h2',
            { className: styles.leftHeaderTab },
            _react2.default.createElement(_reactBootstrap.Glyphicon, { className: styles.icon, glyph: 'gift' }),
            headerTitle
          )
        ),
        _react2.default.createElement(
          'div',
          {
            className: styles.bodyBox + ' ' + (promotionCards.length === 1 && styles.onlyOne)
          },
          promotionCards
        ),
        !staticOn && _react2.default.createElement('div', { className: styles.bottomDynamicBg }),
        _react2.default.createElement(
          _reactBootstrap.Modal,
          {
            onHide: this.closeModal,
            show: showModal,
            className: styles.modal
          },
          _react2.default.createElement(
            _reactBootstrap.Modal.Header,
            { closeButton: true },
            _react2.default.createElement(
              'div',
              { className: styles.modalHeader },
              _react2.default.createElement(
                'span',
                { className: styles.tilte },
                card.title
              ),
              _react2.default.createElement(
                'span',
                { className: styles.range },
                'Hiệu lực từ ' + (0, _moment2.default)(card.start_date).format('DD/MM/YYYY') + ' đến ' + (0, _moment2.default)(card.end_date).format('DD/MM/YYYY')
              )
            )
          ),
          _react2.default.createElement(
            _reactBootstrap.Modal.Body,
            null,
            _react2.default.createElement('div', {
              className: styles.modalBody,
              dangerouslySetInnerHTML: { __html: card.description }
            })
          )
        )
      );
    }
  }]);
  return PromotionDetail;
}(_react.Component), _class2.propTypes = {
  history: _react.PropTypes.object,
  // @data
  shopId: _react.PropTypes.string,
  isJoin: _react.PropTypes.bool,
  promotionDetailLoaded: _react.PropTypes.bool,
  campaigns: _react.PropTypes.array,
  allRewards: _react.PropTypes.object,
  detail: _react.PropTypes.object,
  staticOn: _react.PropTypes.bool,
  noCallHomeService: _react.PropTypes.bool,
  location: _react.PropTypes.object,
  // @action
  getAllCampaignByShop: _react.PropTypes.func,
  getAllReward: _react.PropTypes.func,
  push: _react.PropTypes.func,
  onChange: _react.PropTypes.func
}, _temp2)) || _class);
exports.default = PromotionDetail;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/Detail/PromotionDetail.js
// module id = 1591
// module chunks = 0